import { render, staticRenderFns } from "./SubDrawer.vue?vue&type=template&id=2cd0aa20&scoped=true"
import script from "./SubDrawer.vue?vue&type=script&lang=ts"
export * from "./SubDrawer.vue?vue&type=script&lang=ts"
import style0 from "./SubDrawer.vue?vue&type=style&index=0&id=2cd0aa20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd0aa20",
  null
  
)

export default component.exports